import PropTypes from "prop-types";
import React from 'react'
import AniLink from 'gatsby-plugin-transition-link/AniLink'
import kebabCase from 'lodash/kebabCase'

const DuoNav = ({ left, right }) => {

  return (
    <div className="w-full lg:mt-12 flex flex-row uppercase font-display tracking-wide text-base lg:text-xl">
    <AniLink 
      to={`/${kebabCase(left)}/`}
      swipe
      top="exit" 
      direction="right"
      duration={.3}
      className="hover:text-orange-500 block w-1/2">
          <span className="text-criptoBlue-500 hover:text-criptoBlue-900 text-3xl mr-1">
          &#60;&#60;
          </span>Procurar por {left}
    </AniLink>
    <AniLink 
      to={`/${kebabCase(right)}/`}
      swipe
      top="exit" 
      direction="left"
      duration={.3}
      className="hover:text-orange-500 block w-1/2 text-right">Procurar por {right}
        <span className="text-criptoBlue-500 hover:text-criptoBlue-900 text-3xl ml-1">
          >>
          </span>
    </AniLink>
  </div>
  )
}

DuoNav.propTypes = {
  left: PropTypes.any,
  right: PropTypes.any
}

export default DuoNav
  
